import type { TOC } from '@ember/component/template-only';

import CommonAddButtonComponent from 'webapp/components/common/add-button';
import EmptyScreensOkrsComponent from 'webapp/components/empty-screens/okrs';
import EmptyScreensStrategyComponent from 'webapp/components/empty-screens/strategy';
import GoalsStrategyOverviewComponent from 'webapp/components/goals/strategy/overview';
import GoalsStrategyTableComponent from 'webapp/components/goals/strategy/table';
import GoalsTreeComponent from 'webapp/components/goals/tree/index';
import type GoalsStrategyController from 'webapp/controllers/goals/strategy';

interface Args {
	controller: GoalsStrategyController;
}

const GoalsStrategyRouteTemplate: TOC<Args> = <template>
	{{#if @controller.showEmptyPage}}
		<EmptyScreensOkrsComponent />
	{{else}}
		{{#if @controller.isOverviewVisible}}
			<GoalsStrategyOverviewComponent
				@goals={{@controller.filterSortGoals}}
				@toggleOverview={{@controller.toggleOverview}}
				@showEmptyState={{@controller.showEmptyState}}
			/>
		{{/if}}

		{{#if @controller.showGoalsList}}
			<div class="view-{{@controller.viewId}}">
				{{#if @controller.isTableView}}
					<GoalsStrategyTableComponent
						@model={{@controller.model}}
						@addNew={{@controller.createNewGoal}}
						@openView={{@controller.openView}}
						@onFilterSortChange={{@controller.onFilterSortChange}}
					/>
				{{else}}
					<GoalsTreeComponent @openView={{@controller.openView}} />
				{{/if}}
			</div>
		{{else}}
			<EmptyScreensStrategyComponent
				@onCreate={{@controller.createNewGoal}}
				@isInfoSectionHidden={{true}}
			/>

		{{/if}}

		{{#if @controller.navigationService.addButtonContainerNode}}
			{{#in-element @controller.navigationService.addButtonContainerNode}}
				<CommonAddButtonComponent
					@text="New goal"
					@callTrigger={{@controller.createNewGoal}}
				/>
			{{/in-element}}
		{{/if}}
	{{/if}}
</template>;

export default GoalsStrategyRouteTemplate;
